import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import LoadingSpinner from "./LoadingSpinner";
import { useAuth } from "../context/AuthContext";

interface RequireSuperAdminProps {
  children: React.ReactNode;
}

const RequireSuperAdmin: React.FC<RequireSuperAdminProps> = ({ children }) => {
  const { user, isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!loading && (!isAuthenticated || !user?.isSuperAdmin)) {
      navigate("/", {
        replace: true,
        state: { from: location.pathname },
      });
    }
  }, [isAuthenticated, loading, navigate, location, user]);

  if (loading) {
    return <LoadingSpinner message="Chargement des autorisations..." />;
  }

  if (!isAuthenticated || !user?.isSuperAdmin) {
    return null;
  }

  return <>{children}</>;
};

export default RequireSuperAdmin;













